import React from 'react';
import { CellProps } from 'react-table';
import { TooltipMoney } from 'common/components';
import { BillingByRoleData } from 'common/types';
import { usePlanTotalContext } from 'plans/plan/context';

export const RevenueFooter: React.FC<CellProps<BillingByRoleData>> = () => {
  const { revenue } = usePlanTotalContext();

  return (
    <TooltipMoney
      currencySymbol={revenue?.currency?.symbol ?? ''}
      value={revenue?.amount?.toNumber() ?? 0}
      placement="right"
    />
  );
};
